// [HACK] This is a horrible way to do this, but struggling to find ways to keep the horizontal scroll on small
// screens at the same time as allowing alignment options

const init = () => {

	const detectInsightPage = document.getElementById('insight-content');
	if (detectInsightPage) {
		return;
	}

	const tables = document.querySelectorAll('.force-aligned-content table');

	window.addEventListener('resize', () => {
		tables.forEach((table) => {
			if (table.offsetWidth + 40 > window.outerWidth) {
				table.parentElement.parentElement.classList.add('force-aligned-content--wider-than-screen');
				table.parentElement.parentElement.parentElement.parentElement.classList.remove('flex');
			} else {
				table.parentElement.parentElement.classList.remove('force-aligned-content--wider-than-screen');
				table.parentElement.parentElement.parentElement.parentElement.classList.add('flex');
			}
		});
	});
}

export default init